function ErrorPage() {
  return (
    <>
      <h1>Error Page not found 404!</h1>
    </>
  );
}

export default ErrorPage;
